export default __webpack_public_path__ + "static/media/goran.608438b4.jpg";